import { isExternal, isEmpty, observeBackgrounds, dropdownState } from '../util/helpers'

export default {
  init() {
    // JavaScript to be fired on all pages
    const body = document.querySelector('body')
    const navToggle = document.querySelector('.js-toggle-nav')
    const anchors = document.querySelectorAll('a')
    const paragraphs = document.querySelectorAll('p')
    const dropdowns = document.querySelectorAll('.menu-item-has-children')
    const heroBackground = document.querySelector('.js-hero')
    const jsBackgrounds = document.querySelectorAll('.js-background')
    const galleryThumbs = document.querySelectorAll('.gallery-icon')
    const callToAction = document.querySelector('.section--action')

    // Handle external urls
    anchors.forEach(anchor => {
      if (isExternal(anchor)) {
        // Define attributes to set
        const attributes = {
          target: '__blank',
          rel: 'noopener',
        }

        // Set attributes
        Object.keys(attributes).forEach(attribute => {
          anchor.setAttribute(attribute, attributes[attribute])
        })
      }
    })

    // Handle empty p tags
    paragraphs.forEach(isEmpty)

    // Handle toggling mobile navigation
    if (window.matchMedia('(max-width: 1023px)').matches) {
      if (navToggle) {
        navToggle.addEventListener('click', () => {
          body.classList.toggle('nav-is-open')
        })
      }
    }

    // Handle dropdowns visibility state
    if (window.matchMedia('(max-width: 1199px)').matches) {
      dropdowns.forEach(dropdown => {
        dropdown.setAttribute('data-state', 'closed')

        dropdown.addEventListener('click', dropdownState)
      })
    }

    // Handle hero background
    if (heroBackground) {
      const mobileHero = heroBackground.dataset.mobile
      const desktopHero = heroBackground.dataset.desktop

      if (mobileHero && desktopHero) {
        heroBackground.classList.add('has-bg')

        if (window.matchMedia('(min-width: 1024px)').matches) {
          heroBackground.style.backgroundImage = `url(${desktopHero})`
        } else {
          heroBackground.style.backgroundImage = `url(${mobileHero})`
        }
      }
    }

    // Handle js backgrounds
    if (jsBackgrounds) {
      if (('IntersectionObserver' in window)) {
        let observer = new IntersectionObserver(observeBackgrounds);

        jsBackgrounds.forEach(jsBackground => {
          observer.observe(jsBackground)
        })
      }
    }

    // Handle gallery lightbox
    if (galleryThumbs) {
      galleryThumbs.forEach(galleryThumb => {
        const galleryAnchor = galleryThumb.children[0]

        galleryAnchor.setAttribute('data-fancybox', 'gallery')
      })

      $('[data-fancybox]').fancybox()
    }

    // Handle testimonials
    if ($('.js-testimonials').length) {
      $('.js-testimonials').slick({
        accessibility: true,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 10000,
        arrows: true,
        dots: false,
        prevArrow: '<button type="button" class="hidden slick-prev" aria-label="Previous Testimonials"></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Next Testimonials"></button>',
        slidesToShow: 2,
        slidesToScroll: 2,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              arrows: false,
              dots: true,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      }).on('setPosition', function (event, slick) {
        slick.$slides.css('height', slick.$slideTrack.height() + 'px')
      })
    }

    // Handle call to action
    if (callToAction) {
      if (window.matchMedia('(min-width: 1024px)').matches) {
        document.body.style.paddingBottom = `${callToAction.offsetHeight}px`
      }
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js